import React, { useState, useEffect } from 'react';
import BbPreview from '../components/BbPreview/BbPreview';

/**
 * BbPreview Page Component
 * Main page that renders the BbPreview component
 * Extracts bb_course_id from URL query parameters
 */
const BbPreviewPage = () => {
  const [bbCourseId, setBbCourseId] = useState(null);

  useEffect(() => {
    // Extract bb_course_id from URL query parameters
    const urlParams = new URLSearchParams(window.location.search);
    const courseId = urlParams.get('bb_course_id');

    if (courseId) {
      setBbCourseId(courseId);
    } else {
      console.warn('No bb_course_id found in URL parameters.');
    }
  }, []);

  if (!bbCourseId) {
    return (
      <div className="container mt-4">
        <div className="alert alert-warning" role="alert">
          <h4 className="alert-heading">Missing Course ID</h4>
          <p>No Bright Space course ID provided in the URL.</p>
          <p className="mb-0">
            Please access this page with a valid course ID: 
            <code className="ms-2">/bbpreview?bb_course_id=YOUR_COURSE_ID</code>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <BbPreview bbCourseId={bbCourseId} />
    </div>
  );
};

export default BbPreviewPage;
